<template>
  <thead>
    <tr>
      <th></th>
      <th
        class="text-center"
        v-for="(row, index) in rows"
        :key="`row-${index}`"
      >
        {{ row }}
      </th>
      <th></th>
    </tr>
  </thead>
</template>

<script>
// @ is an alias to /src
export default {
  name: "UnitScaleHeader",
  props: {
    max: {
      type: Number,
      default: 3,
    },
    min: {
      type: Number,
      default: -3,
    },
  },
  computed: {
    rows() {
      const rows = [];
      for (let a = this.min; a < 0; a++) {
        rows.push(a);
      }
      for (let b = 0; b <= this.max; b++) {
        rows.push(b);
      }
      console.log(rows);
      return rows;
    },
  },
};
</script>

<style lang="scss">
.theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0px !important;
  width: 20px;
}
</style>
